export enum AdjustmentClassificationEnum {
  _1A = 0, // Substances regulated by a ceiling value
  _1B = 1, // Irritating or malodorous substances
  _1C = 2, // Simple asphyxiants, low risk whose half-life < 4 hours. Technological limitations
  _2 = 3,  // Short-term effect substances following short-term exposure
  _3 = 4,  // Long-term effect substances following long term exposure
  _4 = 5,  // Short- or long-term effect substances following short term or long term exposure
}

export const AdjustmentClassificationDescriptions: Record<AdjustmentClassificationEnum, string> = {
  [AdjustmentClassificationEnum._1A]: 'Substances regulated by a ceiling value',
  [AdjustmentClassificationEnum._1B]: 'Irritating or malodorous substances',
  [AdjustmentClassificationEnum._1C]: 'Simple asphyxiants, low risk whose half-life < 4 hours. Technological limitations',
  [AdjustmentClassificationEnum._2]: 'Short-term effect substances following short-term exposure',
  [AdjustmentClassificationEnum._3]: 'Long-term effect substances following long term exposure',
  [AdjustmentClassificationEnum._4]: 'Short- or long-term effect substances following short term or long term exposure',
};

// Resulting shift-adjustment basis (reduction factor) per class. This MUST mirror the BE
// OelCorrectionService.ComputeQuebecFactor switch (1A/1B/1C = 1; 2 = 8/h; 3 = 40/wk; 4 = min of the two)
// so the FE hint copy and BE math stay in sync.
export const AdjustmentClassificationEffect: Record<AdjustmentClassificationEnum, string> = {
  [AdjustmentClassificationEnum._1A]: 'No shift adjustment (factor = 1)',
  [AdjustmentClassificationEnum._1B]: 'No shift adjustment (factor = 1)',
  [AdjustmentClassificationEnum._1C]: 'No shift adjustment (factor = 1)',
  [AdjustmentClassificationEnum._2]: 'Daily adjustment — factor = 8 / shift hours',
  [AdjustmentClassificationEnum._3]: 'Weekly adjustment — factor = 40 / weekly hours',
  [AdjustmentClassificationEnum._4]: 'Daily or weekly — whichever gives the lower (more protective) limit',
};

// Class code as shown to users (enum key without the leading underscore), e.g. _1A -> '1A'.
export const getAdjustmentClassificationCode = (value: AdjustmentClassificationEnum): string =>
  AdjustmentClassificationEnum[value].replace(/^_/, '');

// Human-readable dropdown label: code + health-effect description, e.g. '1A — Substances regulated by a ceiling value'.
// The description fragment is translated via the supplied `translate` callback (defaults to identity for
// tests / non-localized callers) so the composed label reads correctly in every locale. The code prefix
// is locale-invariant, so only the description is a translatable i18n key.
export const getAdjustmentClassificationOptionLabel = (
  value: AdjustmentClassificationEnum,
  translate: (key: string) => string = key => key,
): string =>
  `${getAdjustmentClassificationCode(value)} — ${translate(AdjustmentClassificationDescriptions[value])}`;
